import { SxProps, Theme } from '@mui/material';

/**
 * Styles for the search form container
 */
export const searchContainerStyles: SxProps<Theme> = {
  mb: 2,
  p: 2,
  bgcolor: 'background.paper',
  borderRadius: 1,
};

/**
 * Styles for the no results message
 */
export const noResultsStyles: SxProps<Theme> = {
  p: 2,
  textAlign: 'center',
};
